export default __webpack_public_path__ + "static/media/442.54ac0060.png";